import { create } from 'zustand';

/**
 * Session state of the once-only flows (profile wizard, tutorial; #96).
 *
 * The durable „already seen" mark lives in Firestore (`lib/onboarding.ts`);
 * this store only bridges the moment between closing a flow and the snapshot
 * echoing it back, and carries a tutorial that was asked for from Settings.
 */
export type TutorialPhase = 'idle' | 'running';

interface OnboardingStore {
  /** Closed in this session — do not show it again even before the echo. */
  wizardClosed: boolean;
  /** The tutorial question was answered in this session. */
  tutorialAnswered: boolean;
  tutorial: TutorialPhase;
  closeWizard: () => void;
  answerTutorial: (start: boolean) => void;
  startTutorial: () => void;
  stopTutorial: () => void;
}

export const useOnboardingStore = create<OnboardingStore>((set) => ({
  wizardClosed: false,
  tutorialAnswered: false,
  tutorial: 'idle',
  closeWizard: () => set({ wizardClosed: true }),
  answerTutorial: (start) => set({ tutorialAnswered: true, tutorial: start ? 'running' : 'idle' }),
  startTutorial: () => set({ tutorialAnswered: true, tutorial: 'running' }),
  stopTutorial: () => set({ tutorial: 'idle' }),
}));
